export default __webpack_public_path__ + "static/media/agate_agnidus_b_fragment.433163af.png";